var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Phone01Svg from './phone-01.icon.svg';
export const Phone01Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: Phone01Svg }));
_react_refresh_temp_1 = Phone01Icon;
$RefreshReg$(_react_refresh_temp_1, "Phone01Icon");
